






















import { Component, Vue } from 'vue-property-decorator'
import { arriveParkingService } from '@/services/api/arrive-parking.service'
import { ParkingLocationInterface } from '@/interfaces/entities/parking-location.interface'

@Component
export default class ProductParkingSelectionsComponent extends Vue {
  private location: ParkingLocationInterface = {}

  mounted() {
    this.getLocation()
  }

  async getLocation() {
    this.location = await arriveParkingService.getLocation(9830)
  }
}
